import {AxiosInstance, AxiosResponse, AxiosRequestConfig} from 'axios';
import {isEqual} from 'lodash';

type ContainerItem = {
    request: {
        url: string;
        config?: AxiosRequestConfig;
    };
    response: Promise<AxiosResponse<Description[]>>;
    getSortFn: () => {};
};

type Description = {
    Id: number;
    Description: string;
};

export default class DescriptionsContainer {
    container: ContainerItem[];
    http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.container = [];
        this.http = http;
    }

    get(url: string, config?: AxiosRequestConfig) {
        const detected = this.container.find(item => item.request.url === url && isEqual(item.request.config, config));
        if (detected) return detected.response;
        else {
            return this._get(url, config).response;
        }
    }

    getSortFn(url: string, config?: AxiosRequestConfig) {
        const detected = this.container.find(item => item.request.url === url && isEqual(item.request.config, config));
        if (detected) return detected.getSortFn();
        else {
            return this._get(url, config).getSortFn();
        }
    }

    _getDescriptionsMap(descriptions: Array<{Id: number; Description: string}>) {
        let map = new Map();
        for (const [index, item] of descriptions.entries()) {
            map.set(item.Id, index);
        }
        return map;
    }

    _get(url: string, config?: AxiosRequestConfig) {
        const response = this.http.get(url, config);

        let desMap: any;
        response.then(({data}) => {
            desMap = this._getDescriptionsMap(data);
        });
        let item = {
            request: {
                url,
                config,
            },
            response,
            getSortFn: () => (a: number, b: number) => {
                return desMap.get(a) - desMap.get(b);
            },
        };
        this.container.push(item);
        return item;
    }
}
